import { get } from 'lodash-es';
import { message } from '@fuxi/eevee-ui';
import { handleLogout, safeToLogin, isCanceledError } from 'common/utils';

export default function errorHandler(error: any) {
  // Ignore error when request is canceled by user:
  if (isCanceledError(error)) return;

  const status: number = get(error, 'response.status', 0);
  const code: number = get(error, 'response.data.code', 0);
  const msg = get(error, 'response.data.message') || get(error, 'response.data.msg', '服务端异常');

  // http级别错误处理
  if (status === 401) {
    handleLogout();
    safeToLogin();
  } else {
    const msg = get(error, 'response.data.message', get(error, 'response.data.msg', '服务端异常'));
    message.error(msg);
  }

  return Promise.reject({ status, code, msg });
}
